
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/easytrade",
      function () {
        return require("private-next-pages/easytrade/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/easytrade"])
      });
    }
  